/**
 * Acquisition provider display labels and admin badge colors (PBI #1263).
 *
 * Labels must stay in sync with
 * `ScheduledSmiles.Api/Constants/AcquisitionProviders.cs`. Colors use
 * `brandColors` palette names so each network is scannable in Customer Details.
 */

import { brandColors } from '../config/theme';

/** Matches API `AcquisitionProviders.GoogleAds`. */
export const ACQUISITION_PROVIDER_GOOGLE_ADS = 'Google Ads';

/** Matches API `AcquisitionProviders.OpenAiAds`. */
export const ACQUISITION_PROVIDER_OPENAI_ADS = 'OpenAI Ads';

/** Matches API `AcquisitionProviders.MicrosoftAds`. */
export const ACQUISITION_PROVIDER_MICROSOFT_ADS = 'Microsoft Ads';

/** Matches API `AcquisitionProviders.MetaAds`. */
export const ACQUISITION_PROVIDER_META_ADS = 'Meta Ads';

/** Matches API `AcquisitionProviders.PaidUtm`. */
export const ACQUISITION_PROVIDER_PAID_UTM = 'Paid (UTM)';

/** Matches API `AcquisitionProviders.AiAssistant`. */
export const ACQUISITION_PROVIDER_AI_ASSISTANT = 'AI assistant';

/** Matches API `AcquisitionProviders.Other`. */
export const ACQUISITION_PROVIDER_OTHER = 'Other';

/**
 * Mantine `color` palette name for an acquisition Provider badge.
 * Distinct hues help admins spot Google vs OpenAI vs Meta at a glance.
 */
export function getAcquisitionProviderBadgeColor(
  provider: string | null | undefined,
): string {
  switch (provider) {
    case ACQUISITION_PROVIDER_GOOGLE_ADS:
      return brandColors.info;
    case ACQUISITION_PROVIDER_OPENAI_ADS:
      return brandColors.feature;
    case ACQUISITION_PROVIDER_MICROSOFT_ADS:
      return brandColors.scheduling;
    case ACQUISITION_PROVIDER_META_ADS:
      return brandColors.primary;
    case ACQUISITION_PROVIDER_PAID_UTM:
      return brandColors.warmAccent;
    case ACQUISITION_PROVIDER_AI_ASSISTANT:
      return brandColors.admin;
    case ACQUISITION_PROVIDER_OTHER:
    default:
      return brandColors.neutral;
  }
}
